import { createI18n } from 'vue-i18n'
import zhHans from '@/locales/zh-Hans.json';
import zhHant from '@/locales/zh-Hant.json';
import en from '@/locales/en.json';

const messages = {
  'zh': zhHans,
  'zh-Hant': zhHant,
  'en': en
};

const i18n = new createI18n({
  locale: navigator.language.split('-')[0], // 使用浏览器的语言设置
  fallbackLocale: 'zh',
  messages
});

export default i18n;